'use strict';

exports.__esModule = true;
exports.getCustomTagsString = undefined;

var _renderToStaticMarkup = require('../../renderer/render-to-static-markup');

var _isEmpty = require('../utils/is-empty');

var getCustomTagsString = exports.getCustomTagsString = function getCustomTagsString(tags) {
  return (0, _isEmpty.isEmpty)(tags) ? '' : (0, _renderToStaticMarkup.renderToStaticMarkup)({ tags: tags.filter(function (tag) {
      return tag.custom;
    }) }).join('\n');
};